module.exports = __webpack_public_path__ + "static/media/tick-green.c2fbbcd4.svg";